// Upwardor — the original admin portal brand (unchanged appearance).
const upwardor = {
  key: "upwardor",
  name: "Upwardor",
  legalName: "Upwardor Inc.",
  title: "Upwardor | Admin",
  assets: {
    logo: "/assets/img/upwardor-connect-FINAL.png", // light backgrounds (sidebar, auth pages)
    logoOnDark: "/assets/img/upwardor-connect-FINAL-white.png", // login panel
    favicon: "/assets/img/fav.png",
    manifest: "/manifest.json",
    // Extra classes for the logo frame on the photo-background auth pages.
    authLogoClass: "",
  },
  // Quote-summary extras; none for Upwardor (installation stays a dealer-side
  // price in the customer portal's Prepare Customer Quote, never sent to BC).
  features: {
    installationLines: false,
    installationDefaults: false,
    customerPdf: false,
    // Admin > Customer Survey: the feedback banner on the customer portal dashboard.
    customerSurvey: true,
  },
  // Login / forgot / reset pages. These are the exact classes the pages used
  // before brands existed — Upwardor's screens are unchanged.
  auth: {
    backdropClass: "bg-[url('/assets/img/auth-bg.jpg')]   bg-no-repeat bg-cover",
    stripClass: "bg-[#8080748C] py-6 pl-3 lg:py-6 lg:pl-12",
    tagline: "classic",
    accentBg: "bg-[#808074]",
    linkText: "text-[#808074]",
    iconBox: "bg-[#00358512] text-[#808074]",
    buttonText: "text-white",
    accentColor: "#808074",
  },
};

export default upwardor;
